<template>
  <v-container fluid class="job-teams">
    <v-container v-if="!isVisitDetail">
      <v-layout class="justify-start mb-1">
        <DateRangePicker
          placeholder="Data Range"
          v-model="dates"
          v-on:update:model-value="getToolRequestList()"
          v-on:click:clear="clearFilter('dates')"
          class="mr-2"
        ></DateRangePicker>

        <div class="ml-2">
          <v-tooltip top content-class="custom-top-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                v-bind="attrs"
                v-on="on"
                class="ml-2 custom-bold-button white--text"
                color="cyan"
                tile
                :disabled="requestLoading"
                v-on:click="getToolRequestList"
              >
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>Reload</span>
          </v-tooltip>
        </div>
      </v-layout>
    </v-container>
    <v-skeleton-loader
      type="text@5"
      class="custom-skeleton table-rows-text"
      v-if="requestLoading"
    ></v-skeleton-loader>
    <v-simple-table
      v-else
      class="inner-simple-table"
      :class="{ 'custom-border-top': !isVisitDetail }"
      fixed-header
    >
      <template v-slot:default>
        <thead>
          <tr class="custom-border-bottom">
            <td class="font-size-16 font-weight-500 text-uppercase">#</td>
            <td
              class="font-size-16 font-weight-500 text-uppercase"
              v-if="!toolId"
            >
              Tool ID
            </td>
            <td class="font-size-16 font-weight-500 text-uppercase">
              From Visit ID
            </td>
            <td class="font-size-16 font-weight-500 text-uppercase">
              To Visit ID
            </td>
            <td class="font-size-16 font-weight-500 text-uppercase">
              Requested Start
            </td>
            <td class="font-size-16 font-weight-500 text-uppercase">
              Requested End
            </td>
            <td class="font-size-16 font-weight-500 text-uppercase">
              Requested By
            </td>
            <td class="font-size-16 font-weight-500 text-uppercase">Status</td>
            <td class="font-size-16 font-weight-500 text-uppercase">
              Approver
            </td>
            <!--  <td class="font-size-16 font-weight-500 text-uppercase">
              Rejection Info
            </td> -->
          </tr>
        </thead>
        <tbody>
          <template v-if="requestList && requestList.length > 0">
            <tr v-for="(data, index) in requestList" :key="index">
              <td class="cursor-pointer font-size-16 font-weight-500">
                {{ index + 1 }}
              </td>

              <td
                class="cursor-pointer font-size-16 font-weight-500"
                v-if="!toolId"
              >
                <template v-if="data?.tool_relation?.barcode">
                  <Barcode
                    dense
                    small
                    :barcode="data.tool_relation.barcode"
                    :id="data.tool_relation.id"
                    :route="'equipment.detail'"
                  ></Barcode>
                </template>
                <template v-else><em class="text-muted">No Tool </em></template>
              </td>
              <td class="cursor-pointer font-size-16 font-weight-500">
                <template v-if="data?.receive_visit_relation?.trip_barcode">
                  <Barcode
                    dense
                    small
                    :id="data.receive_visit_relation.id"
                    :route="'visit.detail'"
                    :barcode="data.receive_visit_relation.trip_barcode"
                  ></Barcode>
                </template>
                <template v-else
                  ><em class="text-muted">No visit </em></template
                >
              </td>
              <td class="cursor-pointer font-size-16 font-weight-500">
                <template v-if="data?.send_visit_relation?.trip_barcode">
                  <Barcode
                    dense
                    small
                    :route="'visit.detail'"
                    :id="data.send_visit_relation.id"
                    :barcode="data.send_visit_relation.trip_barcode"
                  ></Barcode>
                </template>
                <template v-else
                  ><em class="text-muted">No visit </em></template
                >
              </td>
              <td class="cursor-pointer font-size-16 font-weight-500">
                <template v-if="data && data.request_start">
                  {{ formatDate(data.request_start) }}
                  {{ formatDateStartTime(data.request_start) }}
                </template>
                <template v-else
                  ><em class="text-muted">No request start date </em></template
                >
              </td>
              <td class="cursor-pointer font-size-16 font-weight-500">
                <template v-if="data && data.request_end">
                  {{ formatDate(data.request_end) }}
                  {{ formatDateStartTime(data.request_end) }}
                </template>
                <template v-else
                  ><em class="text-muted">No request end date </em></template
                >
              </td>
              <td class="cursor-pointer font-size-16 font-weight-500">
                <div
                  class="custom-table-content max-width-150px"
                  v-if="data?.send_by?.display_name"
                >
                  <v-chip
                    v-if="!lodash.isEmpty(data.send_by)"
                    class="mb-1 custom-grey-border"
                    color="cyan darken-1"
                    text-color="white"
                    small
                    label
                  >
                    <p class="m-0 custom-nowrap-ellipsis">
                      {{ data.send_by.display_name }}
                    </p>
                  </v-chip>
                  <div>
                    <v-chip
                      class="mb-1 custom-grey-border"
                      color="cyan darken-1"
                      text-color="white"
                      small
                      label
                    >
                      <p class="m-0 custom-nowrap-ellipsis">
                        {{ formatDate(data.send_date) }}
                        {{ formatDateStartTime(data.send_date) }}
                      </p>
                    </v-chip>
                  </div>
                </div>
                <template v-else
                  ><em class="text-muted">No request Info </em></template
                >
              </td>

              <td class="cursor-pointer font-size-16 font-weight-500">
                <template v-if="data && data.status">
                  <v-tooltip top content-class="custom-top-tooltip">
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        v-bind="attrs"
                        v-on="on"
                        class="mb-1 custom-status font-weight-600 custom-grey-border text-uppercase justify-center font-10"
                        :color="data.status_color"
                        label
                        small
                        text-color="white"
                      >
                        {{ data.status }}
                      </v-chip>
                    </template>
                    <span>Status</span>
                  </v-tooltip>
                </template>
                <div>
                  <template v-if="data && data.priority">
                    <v-tooltip bottom content-class="custom-bottom-tooltip">
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip
                          v-bind="attrs"
                          v-on="on"
                          class="custom-status font-weight-600 custom-grey-border text-uppercase justify-center font-10"
                          :color="
                            data.priority == 'high'
                              ? 'red'
                              : data.priority == 'medium'
                              ? 'orange'
                              : 'green'
                          "
                          label
                          small
                          text-color="white"
                        >
                          {{ data.priority }}
                        </v-chip>
                      </template>
                      <span>Priority</span>
                    </v-tooltip>
                  </template>
                </div>
              </td>

              <td class="cursor-pointer font-size-16 font-weight-500">
                <div class="custom-table-content max-width-150px">
                  <!-- Accepted Info -->
                  <template
                    v-if="
                      data?.accepted_by?.display_name && data?.accepted_date
                    "
                  >
                    <v-chip
                      class="mb-1 custom-grey-border"
                      color="green darken-1"
                      small
                      label
                      outlined
                    >
                      <p class="m-0 custom-nowrap-ellipsis">
                        {{ data.accepted_by.display_name }}
                      </p>
                    </v-chip>

                    <div>
                      <v-chip
                        class="mb-1 custom-grey-border"
                        color="green darken-1"
                        small
                        label
                        outlined
                      >
                        <p class="m-0 custom-nowrap-ellipsis">
                          {{ formatDate(data.accepted_date) }}
                          {{ formatDateStartTime(data.accepted_date) }}
                        </p>
                      </v-chip>
                    </div>
                  </template>

                  <!-- Rejected Info -->
                  <template
                    v-else-if="
                      data?.rejected_by?.display_name && data?.rejected_date
                    "
                  >
                    <v-chip
                      class="mb-1 custom-grey-border"
                      color="red darken-1"
                      small
                      label
                      outlined
                    >
                      <p class="m-0 custom-nowrap-ellipsis">
                        {{ data.rejected_by.display_name }}
                      </p>
                    </v-chip>

                    <div>
                      <v-chip
                        class="mb-1 custom-grey-border"
                        color="red darken-1"
                        small
                        label
                        outlined
                      >
                        <p class="m-0 custom-nowrap-ellipsis">
                          {{ formatDate(data.rejected_date) }}
                          {{ formatDateStartTime(data.rejected_date) }}
                        </p>
                      </v-chip>
                    </div>
                  </template>

                  <!-- No Info -->
                  <template v-else>
                    <em class="text-muted">No Action</em>
                  </template>
                </div>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td :colspan="9">
                <p
                  class="m-0 row-not-found text-center font-weight-500 font-size-16"
                >
                  Sorry! No Tool Request(s) Found.
                </p>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </v-container>
</template>

<script>
import DateRangePicker from "@/view/components/DateRangePicker";
import moment from "moment-timezone";
import Barcode from "@/view/pages/partials/Barcode.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import JobRequestMixin from "@/core/lib/job/api.request.job.mixin";
import { QUERY } from "@/core/services/store/request.module";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  mixins: [CommonMixin, JobRequestMixin],
  props: {
    pageLoading: {
      type: Boolean,
      default: false,
    },
    isVisitDetail: {
      type: Boolean,
      default: false,
    },
    visitId: {
      type: Number,
      default: 0,
    },
    toolId: {
      type: Number,
      default: 0,
    },
  },
  data: () => {
    return {
      dates: [],
      datePicker: false,
      requestList: [],
      filter: {
        search: null,
        visit: 0,
      },
      requestLoading: false,
    };
  },
  components: {
    Barcode,
    DateRangePicker,
  },
  watch: {},
  methods: {
    formatDateStartTime(row) {
      return moment(row).format("hh:mm A");
    },
    getToolRequestList() {
      this.requestLoading = true;
      let filter = {
        receive_visit_id: this.visitId ?? 0,
        tool_id: this.toolId ?? 0,
        /*  send_visit_id: this.visitId ?? 0, */
        dates: this.dates ?? [],
      };
      this.$store

        .dispatch(QUERY, {
          url: "release-receive/tool",
          data: filter,
        })
        .then(({ data }) => {
          this.requestList = data.rows;
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.requestLoading = false;
        });
    },

    clearFilter(field) {
      const _this = this;
      switch (field) {
        case "search":
          _this.filter.search = null;
          break;
        case "dates":
          _this.dates = [];
          break;
      }
      this.getToolRequestList();
    },
  },
  mounted() {
    this.getToolRequestList();
  },
};
</script>
<style scoped>
.inner-simple-table thead tr.custom-border-bottom td {
  color: #24326d !important;
}
</style>
